var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var EmailGroupService = /** @class */ (function (_super) {
            __extends(EmailGroupService, _super);
            function EmailGroupService(injectedBreeze, $q) {
                return _super.call(this, injectedBreeze, $q) || this;
            }
            EmailGroupService.prototype.getAllProcessEmailGroups = function (appConfigId) {
                var query = this.breezeModule.EntityQuery
                    .from("EmailGroups")
                    .where('processConfiguration_id', '==', appConfigId)
                    .expand('myEmailAddresses');
                return this.executeQuery(query);
            };
            EmailGroupService.prototype.createNewEmailAddress = function () {
                return this.createNewEntity("EmailAddress");
            };
            EmailGroupService.prototype.getById = function (id) {
                return this.fetchById(id, "EmailGroup");
            };
            return EmailGroupService;
        }(services.DataService));
        services.EmailGroupService = EmailGroupService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('EmailGroupService', ['breeze', '$q']);
